// extracted by mini-css-extract-plugin
export var currencyInput = "_jq-1";
export var currencySymbol = "_jq-0";